const voucherStates = {
    vouchers: [],
};
const getters = {
    vouchers(state) {
        return state.vouchers;
    },
};
const mutations = {
    updateVouchers(state, payload) {
        state.vouchers.push(payload);
    },
    resetVouchers(state) {
        state.vouchers.splice(0, state.vouchers.length);
    },
};
export default {
    namespaced: true,
    state: voucherStates,
    getters,
    mutations,
};
